<div class="dcp p-2">
  <div class="modal-header d-block px-0 pt-0">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="modal-title mb-0">Assign Kroll ID</h2>
      <div class="btn-light btn-position" (click)="closeModal()"><span class="mat-icon material-icons">close</span></div>
    </div>
  </div>

  <div class="modal-body px-0">
    <p><strong>Please fix:</strong> We have found a few discrepancies in the Kroll ID assigned on Pilldash and what we are getting in these orders.</p>

    <!-- Filter Section -->
   <div class="row justify-content-end">
      <div class="col-md-4">
        <div class="filter-section mb-3">
          <mat-select class="form-control" [(ngModel)]="selectedFilter" (selectionChange)="applyFilter()">
            <mat-option value="all">All</mat-option>
            <mat-option value="mismatch">Kroll ID Mismatch</mat-option>
            <mat-option value="notAssigned">ID Not Assigned</mat-option>
          </mat-select>
        </div>
      </div>
   </div>

    <form [formGroup]="form" (ngSubmit)="formSubmit()">
      <div class="table-responsive">
        <table class="table table-bordered border table-thbold">
          <thead>
            <tr>
              <th>
                <mat-checkbox [checked]="allSelected" (change)="selectAll($event)">Select All</mat-checkbox>
              </th>
              <th>Pillway User ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Kroll ID Assigned on Pilldash</th>
              <th>ID From Kroll</th>
              <th class="word-break">Status

              <span
                [matMenuTriggerFor]="menu"
                class="material-symbols-outlined vertical-align-middle ml-1">
                info
              </span>

                <mat-menu #menu="matMenu" class="custom-tooltip">
                  <div class="statusTooltip">
                    <strong class="d-block mb-2">Here is what these statuses mean</strong>
                    <ol>
                      <li class="mb-1">
                        <strong>1. Kroll ID Mismatch:</strong> The Kroll ID which is assigned on Pilldash is different from the ID from Kroll.
                      </li>
                      <li>
                        <strong>2. ID Not assigned:</strong> There is no Kroll ID associated with this user. Kindly add this on Kroll and update here.
                      </li>
                    </ol>
                  </div>
                </mat-menu>

                <!-- <div class="KrollStatus">
                     <span class="material-symbols-outlined vertical-align-middle ml-1">info</span>
                      <div class="statusTooltip">
                        <img src="assets/images/arrow-tooltip.svg" alt="">
                         <b class="d-block mb-2">Here is what these statuses mean</b>
                         <ul>
                             <li><b>1. Kroll ID Mismatch:</b> The Kroll ID which is assigned on Pilldash is different from the ID from Kroll</li>
                             <li><b>2. Id Not assigned:</b> There is no Kroll ID associated with this user. Kindly add this on Kroll and update here.</li>
                         </ul>
                      </div>
                </div> -->

              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of filteredUsers">
              <td>
                <mat-checkbox [formControlName]="'selected_' + user.userId" (change)="updateSelectAllState()"></mat-checkbox>
              </td>
              <td>{{ user.userId }}</td>
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.old_kroll_id || '-' }}</td>
              <td>{{ user.new_kroll_id }}</td>
              <td>
                <span class="badge-custom warning" *ngIf="user.old_kroll_id !== 0" >Kroll ID Mismatch</span>
                <span class="badge-custom danger" *ngIf="user.old_kroll_id === 0">ID Not Assigned</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-primary mr-2" (click)="closeModal()">Cancel</button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!form.valid || disableButton || !isAnyUserSelected()"
        >
          {{ isLoading ? 'Updating...' : getActionButtonLabel() }}
        </button>
      </div>
    </form>
  </div>

</div>
